
import React from 'react';

//Components
import { GIButton } from 'app-components';



const CustomFieldHeader = (props) => {

    const {
        openCustomFieldModal
    } = props;

    const createCustomField = () => {
        openCustomFieldModal();
    };
    
    return (
        <div className = 'margin-bottom-2em'>
            <span>
                <GIButton id='addNewCustomField'labelId='button.create_new_custom_field' onClickHandler={createCustomField} />
            </span>
        </div>
    );
};

export default CustomFieldHeader;